export default __webpack_public_path__ + "static/media/xiaohongshu.5684fb2b.jpg";